import React from 'react';

const NewsletterOptIn = ({ handleOptIn, newsletterList }) => {
    return (
        <label className='checkbox-text'>
            {`Sign me up for Healthline's ${newsletterList} newsletter`}

            <input type='checkbox'
                className='checkbox'
                id='newsletter-opt-in-checkbox'
                name='Newsletter Opt-In'
                value='Newsletter Opt-In'
                onClick={() => handleOptIn(newsletterList)}
            />

            <span className='checkmark'></span>
        </label>
    )
}

export default NewsletterOptIn;